import * as c from '../constants';
export function reducer(state = c.DEFAULT_STATE, action) {
    switch (action.type) {
        default:
            return state;
    }
}
